function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import isPlainObject from 'isobject';
import { assignStyle } from 'css-in-js-utils';
import { arrayEach } from 'fast-loops';

function resolveResponsiveValues(style, properties, getMediaQueries, props) {
  var _loop = function _loop(property) {
    var value = style[property]; // resolve nested styles

    if (isPlainObject(value)) {
      style[property] = resolveResponsiveValues(value, properties, getMediaQueries, props);
    }

    if (properties[property]) {
      if (Array.isArray(value)) {
        var mediaQueries = getMediaQueries(value, props);

        var _value = _toArray(value),
            defaultValue = _value[0],
            mediaValues = _value.slice(1);

        style[property] = defaultValue;
        arrayEach(mediaQueries.slice(0, mediaValues.length), function (query, index) {
          assignStyle(style, _defineProperty({}, query, _defineProperty({}, property, mediaValues[index])));
        });
      }
    }
  };

  for (var property in style) {
    _loop(property);
  }

  return style;
}

export default function responsiveValue(getMediaQueries) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function responsiveValuePlugin(style, type, renderer, props) {
    return resolveResponsiveValues(style, properties, getMediaQueries, props);
  };
}